import { render, staticRenderFns } from "./DialogAddLessonVideo.vue?vue&type=template&id=560b6d5a"
import script from "./DialogAddLessonVideo.vue?vue&type=script&lang=js"
export * from "./DialogAddLessonVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560b6d5a')) {
      api.createRecord('560b6d5a', component.options)
    } else {
      api.reload('560b6d5a', component.options)
    }
    module.hot.accept("./DialogAddLessonVideo.vue?vue&type=template&id=560b6d5a", function () {
      api.rerender('560b6d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLessonVideo.vue"
export default component.exports